import React from 'react';
import { Box, Typography, Button } from '@mui/material';

const EmptyPortfolioPreviewState = ({ onCreateAlbum, readOnly = false }) => {
  return (
    <Box sx={{ p: 0 }}>
      <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
        Portfolio
      </Typography>
      <Box sx={{ position: "relative", height: "250px", overflow: "hidden", borderRadius: 2, border: "1px solid #E5E7EB" }}>
        {/* Background Image */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'url("/assets/images/profile_portfolio_cover.png")',
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            zIndex: 1,
          }}
        />
        
        {/* Dark overlay */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 2,
          }}
        />
        
        {/* Centered content */}
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            textAlign: "center",
            zIndex: 3,
          }}
        >
          <Typography variant="h4" sx={{ fontWeight: 600, mb: 1, color: "#4D6BF6" }}>
            Showcase your work
          </Typography>
          <Typography variant="h5" sx={{ fontWeight: 500, mb: 3, color: "black" }}>
            to attract potential clients
          </Typography>
          {!readOnly && onCreateAlbum && (
            <Button
              variant="outlined"
              onClick={onCreateAlbum}
              sx={{
                backgroundColor: "white",
                border: "1px solid #D1D5DB",
                borderRadius: 2,
                textTransform: "none",
                px: 4,
                py: 1.5,
                fontSize: "16px",
                fontWeight: 600,
                color: "black",
                "&:hover": {
                  backgroundColor: "#F9FAFB",
                  border: "1px solid #D1D5DB",
                },
              }}
            >
              Upload your portfolio
            </Button>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default EmptyPortfolioPreviewState;
